import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Input from '../../components/abstractObjects/Input';
import { RadioYesNoNull } from '../../components/abstractObjects/RadioYesNo'
import { CheckBox } from '../../components/abstractObjects/CheckBox'
import { Label, BasicLabel, SectionLabel, SectionWithQuestionLabel } from '../../components/abstractObjects/Label'
import { MultipleSelect } from '../../components/abstractObjects/MultipleSelect'
import { 
    selectVarById,
    updateIsShipmentInfoGood,
    updateIsPreAdviceReceivedInTime,
    updateIsPreAdviceWithAllDocs,
    updateIsFlightArrivedOnTime,
    updateIsAtDeliveryReceivedAllRequiredDocuments,
    updateIsBatchesMatchedWithPackingList,
    updateGoodConditionOfBoxesOnArrival,
    updateLabelsAttachedToBoxes,
    updateIsAllShippingBoxesInspected,
    updateIsThereProblemsWithTemperature,
    updateIsThereAlarmsOrExcursionsTemperature,
    updateDateOfInspection,
    updateIsThereAnyAdditionalComments
} from '../var/varSlice'
import QuestionnaireInfoCorrectForm from './Questionnaire/questionnaireInfoCorrectForm'
import { selectAllDevices } from '../devices/devicesSlice'
import { Date, DateTime, ToShortDate } from '../../components/abstractObjects/Date'
import { Translation } from '../../features/translations/getTranslation'
import VarAttachmentsForm from '../varAttachment/attachmentsList';
import VarBatchPackingsForm from '../varBatchPackings/varBatchPackingsList';
import { selectAllVarFieldAttachments } from '../varFieldAttachments/varFieldAttachmentsSlice';

export const QuestionnaireForm = ({ varId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))
    const devices = useSelector(selectAllDevices)
    const varFieldAttachments = useSelector(selectAllVarFieldAttachments)
    var now = new window.Date()

    const [IsShipmentInfoGood, setIsShipmentInfoGood] = useState({ value: varx.IsShipmentInfoGood, error: null })
    const [IsPreAdviceReceivedInTime, setIsPreAdviceReceivedInTime] = useState({ value: varx.IsPreAdviceReceivedInTime, error: null })
    const [DaysPassedBetweenReceiptAndShipment, setDaysPassedBetweenReceiptAndShipment] = useState({ value: varx.DaysPassedBetweenReceiptAndShipment, error: null })
    const [IsPreAdviceWithAllDocs, setIsPreAdviceWithAllDocs] = useState({ value: varx.IsPreAdviceWithAllDocs, error: null })
    const [PreAdviceInvoice, setPreAdviceInvoice] = useState({ value: varx.PreAdviceInvoice, error: null })
    const [PreAdvicePackingList, setPreAdvicePackingList] = useState({ value: varx.PreAdvicePackingList, error: null })
    const [PreAdviceBatchCertificate, setPreAdviceBatchCertificate] = useState({ value: varx.PreAdviceBatchCertificate, error: null })
    const [PreAdviceCertificateOfOrigin, setPreAdviceCertificateOfOrigin] = useState({ value: varx.PreAdviceCertificateOfOrigin, error: null })
    const [PreAdviceCertificateOfConformity, setPreAdviceCertificateOfConformity] = useState({ value: varx.PreAdviceCertificateOfConformity, error: null })
    const [PreAdviceCertificateOfAnalysis, setPreAdviceCertificateOfAnalysis] = useState({ value: varx.PreAdviceCertificateOfAnalysis, error: null })
    const [PreAdviceOtherCertificate, setPreAdviceOtherCertificate] = useState({ value: varx.PreAdviceOtherCertificate, error: null })
    const [PreAdviceAdditionalComments, setPreAdviceAdditionalComments] = useState({ value: varx.PreAdviceAdditionalComments, error: null })
    const [IsFlightArrivedOnTime, setIsFlightArrivedOnTime] = useState({ value: varx.IsFlightArrivedOnTime, error: null })
    const [ActualDateOfArrival, setActualDateOfArrival] = useState({ value: varx.ActualDateOfArrival ? varx.ActualDateOfArrival : `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")}T12:00:00`, error: null })
    const [IsAtDeliveryReceivedAllRequiredDocuments, setIsAtDeliveryReceivedAllRequiredDocuments] = useState({ value: varx.IsAtDeliveryReceivedAllRequiredDocuments, error: null })
    const [Invoice, setInvoice] = useState({ value: varx.Invoice, error: null })
    const [PackingList, setPackingList] = useState({ value: varx.PackingList, error: null })
    const [ReleaseCertificate, setReleaseCertificate] = useState({ value: varx.ReleaseCertificate, error: null })
    const [CertificateOfOrigin, setCertificateOfOrigin] = useState({ value: varx.CertificateOfOrigin, error: null })
    const [CertificateOfConformity, setCertificateOfConformity] = useState({ value: varx.CertificateOfConformity, error: null })
    const [CertificateOfAnalysis, setCertificateOfAnalysis] = useState({ value: varx.CertificateOfAnalysis, error: null })
    const [OtherCertificate, setOtherCertificate] = useState({ value: varx.OtherCertificate, error: null })
    const [ShipmentDocumentComments, setShipmentDocumentComments] = useState({ value: varx.ShipmentDocumentComments, error: null })
    const [IsBatchesMatchedWithPackingList, setIsBatchesMatchedWithPackingList] = useState({ value: varx.IsBatchesMatchedWithPackingList, error: null })
    const [BatchesMatchedWithPackingListComment, setBatchesMatchedWithPackingListComment] = useState({ value: varx.BatchesMatchedWithPackingListComment, error: null })
    const [GoodConditionOfBoxesOnArrival, setGoodConditionOfBoxesOnArrival] = useState({ value: varx.GoodConditionOfBoxesOnArrival, error: null })
    const [GoodConditionOfBoxesOnArrivalComment, setGoodConditionOfBoxesOnArrivalComment] = useState({ value: varx.GoodConditionOfBoxesOnArrivalComment, error: null })
    const [LabelsAttachedToBoxes, setLabelsAttachedToBoxes] = useState({ value: varx.LabelsAttachedToBoxes, error: null })
    const [LabelsAttachedToBoxesComment, setLabelsAttachedToBoxesComment] = useState({ value: varx.LabelsAttachedToBoxesComment, error: null })
    const [IsAllShippingBoxesInspected, setIsAllShippingBoxesInspected] = useState({ value: varx.IsAllShippingBoxesInspected, error: null })
    const [IsThereProblemsWithTemperature, setIsThereProblemsWithTemperature] = useState({ value: varx.IsThereProblemsWithTemperature, error: null })
    const [DeviceIds, setDeviceIds] = useState({ value: varx.DeviceIds, error: null })
    const [ThereProblemsWithTemperatureComment, setThereProblemsWithTemperatureComment] = useState({ value: varx.ThereProblemsWithTemperatureComment, error: null })
    const [IsThereAlarmsOrExcursionsTemperature, setIsThereAlarmsOrExcursionsTemperature] = useState({ value: varx.IsThereAlarmsOrExcursionsTemperature, error: null })
    const [ThereAlarmsOrExcursionsTemperatureComment, setThereAlarmsOrExcursionsTemperatureComment] = useState({ value: varx.ThereAlarmsOrExcursionsTemperatureComment, error: null })
    const [InsColdStoreArrivalDate, setInsColdStoreArrivalDate] = useState({ value: varx.InsColdStoreArrivalDate, error: null })
    const [TemperatureAlarmShakeTestResults, setTemperatureAlarmShakeTestResults] = useState({ value: varx.TemperatureAlarmShakeTestResults, error: null })
    const [DateOfInspection, setDateOfInspection] = useState({ value: varx.DateOfInspection, error: null })
    const [IsThereAnyAdditionalComments, setIsThereAnyAdditionalComments] = useState({ value: varx.IsThereAnyAdditionalComments, error: null })
    const [OtherComments, setOtherComments] = useState({ value: varx.OtherComments, error: null })

    const onIsShipmentInfoGoodChanged = (_, value) => {
        setIsShipmentInfoGood({ value: value == "true", error: null })
        if (value == "true") {
            setIsPreAdviceReceivedInTime({ value: true, error: null })
            setIsPreAdviceWithAllDocs({ value: true, error: null })
            setIsAtDeliveryReceivedAllRequiredDocuments({ value: true, error: null })
            setIsFlightArrivedOnTime({ value: true, error: null })
            setIsAtDeliveryReceivedAllRequiredDocuments({ value: true, error: null })
            setIsBatchesMatchedWithPackingList({ value: true, error: null })
            setGoodConditionOfBoxesOnArrival({ value: true, error: null })
            setLabelsAttachedToBoxes({ value: true, error: null })
            setIsAllShippingBoxesInspected({ value: true, error: null })
            setIsThereProblemsWithTemperature({ value: false, error: null })
            setIsThereAlarmsOrExcursionsTemperature({ value: false, error: null })
            setIsThereAnyAdditionalComments({ value: false, error: null })
        }
        updateQuestion2({ IsShipmentInfoGoodValue: value == 'true' })
    }
    const onIsPreAdviceReceivedInTimeChanged = (_, value) => {
        setIsPreAdviceReceivedInTime({ value: value == "true", error: null })
        updateQuestion3({ IsPreAdviceReceivedInTimeValue: value == 'true' })
    }
    const onDaysPassedBetweenReceiptAndShipmentChanged = (e) => {
        setDaysPassedBetweenReceiptAndShipment({ value: parseInt(e.target.value), error: null })
        updateQuestion3({ DaysPassedBetweenReceiptAndShipmentValue: parseInt(e.target.value) })
    }
    const onIsPreAdviceWithAllDocsChanged = (_, value) => {
        setIsPreAdviceWithAllDocs({ value: value == "true", error: null })
        updateQuestion4({ IsPreAdviceWithAllDocsValue: value == 'true' })
    }
    const onPreAdviceInvoiceChanged = (_, value) => {
        setPreAdviceInvoice({ value: value == true, error: null })
        updateQuestion4({ PreAdviceInvoiceValue: value == true })
    }
    const onPreAdvicePackingListChanged = (_, value) => {
        setPreAdvicePackingList({ value: value == true, error: null })
        updateQuestion4({ PreAdvicePackingListValue: value == true })
    }
    const onPreAdviceBatchCertificateChanged = (_, value) => {
        setPreAdviceBatchCertificate({ value: value == true, error: null })
        updateQuestion4({ PreAdviceBatchCertificateValue: value == true })
    }
    const onPreAdviceCertificateOfOriginChanged = (_, value) => {
        setPreAdviceCertificateOfOrigin({ value: value == true, error: null })
        updateQuestion4({ PreAdviceCertificateOfOriginValue: value == true })
    }
    const onPreAdviceCertificateOfConformityChanged = (_, value) => {
        setPreAdviceCertificateOfConformity({ value: value == true, error: null })
        updateQuestion4({ PreAdviceCertificateOfConformityValue: value == true })
    }
    const onPreAdviceCertificateOfAnalysisChanged = (_, value) => {
        setPreAdviceCertificateOfAnalysis({ value: value == true, error: null })
        updateQuestion4({ PreAdviceCertificateOfAnalysisValue: value == true })
    }
    const onPreAdviceOtherCertificateChanged = (_, value) => {
        setPreAdviceOtherCertificate({ value: value == true, error: null })
        updateQuestion4({ PreAdviceOtherCertificateValue: value == true })
    }
    const onPreAdviceAdditionalCommentsChanged = (e) => {
        setPreAdviceAdditionalComments({ value: e.target.value, error: null })
        updateQuestion4({ PreAdviceAdditionalCommentsValue: e.target.value })
    }
    const onIsFlightArrivedOnTimeChanged = (_, value) => {
        setIsFlightArrivedOnTime({ value: value == "true", error: null })
        updateQuestion5({ IsFlightArrivedOnTimeValue: value = "true" })
    }
    const onActualDateOfArrivalChanged = (value) => {
        setActualDateOfArrival({ value: value, error: null })
        updateQuestion5({ ActualDateOfArrivalValue: value })
    }
    const onIsAtDeliveryReceivedAllRequiredDocumentsChanged = (_, value) => {
        setIsAtDeliveryReceivedAllRequiredDocuments({ value: value == "true", error: null })
        updateQuestion6({ IsAtDeliveryReceivedAllRequiredDocumentsValue: value })
    }
    const onInvoiceChanged = (_, value) => {
        setInvoice({ value: value == true, error: null })
        updateQuestion6({ InvoiceValue: value == true })
    }
    const onPackingListChanged = (_, value) => {
        setPackingList({ value: value == true, error: null })
        updateQuestion6({ PackingListValue: value == true })
    }
    const onReleaseCertificateChanged = (_, value) => {
        setReleaseCertificate({ value: value == true, error: null })
        updateQuestion6({ ReleaseCertificateValue: value == true })
    }
    const onCertificateOfOriginChanged = (_, value) => {
        setCertificateOfOrigin({ value: value == true, error: null })
        updateQuestion6({ CertificateOfOriginValue: value == true })
    }
    const onCertificateOfConformityChanged = (_, value) => {
        setCertificateOfConformity({ value: value == true, error: null })
        updateQuestion6({ CertificateOfConformityValue: value == true })
    }
    const onCertificateOfAnalysisChanged = (_, value) => {
        setCertificateOfAnalysis({ value: value == true, error: null })
        updateQuestion6({ CertificateOfAnalysisValue: value == true })
    }
    const onOtherCertificateChanged = (_, value) => {
        setOtherCertificate({ value: value == true, error: null })
        updateQuestion6({ OtherCertificateValue: value == true })
    }
    const onShipmentDocumentCommentsChanged = (e) => {
        setShipmentDocumentComments({ value: e.target.value, error: null })
        updateQuestion6({ ShipmentDocumentCommentsValue: e.target.value })
    }
    const onIsBatchesMatchedWithPackingListChanged = (_, value) => {
        setIsBatchesMatchedWithPackingList({ value: value == "true", error: null })
        updateQuestion7({ IsBatchesMatchedWithPackingListValue: value == "true" })
    }
    const onBatchesMatchedWithPackingListCommentChanged = (e) => {
        setBatchesMatchedWithPackingListComment({ value: e.target.value, error: null })
        updateQuestion7({ BatchesMatchedWithPackingListCommentValue: e.target.value })
    }
    const onGoodConditionOfBoxesOnArrivalChanged = (_, value) => {
        setGoodConditionOfBoxesOnArrival({ value: value == "true", error: null })
        updateQuestion8({ GoodConditionOfBoxesOnArrivalValue: value == "true" })
    }
    const onGoodConditionOfBoxesOnArrivalCommentChanged = (e) => {
        setGoodConditionOfBoxesOnArrivalComment({ value: e.target.value, error: null })
        updateQuestion8({ GoodConditionOfBoxesOnArrivalCommentValue: e.target.value })
    }
    const onLabelsAttachedToBoxesChanged = (_, value) => {
        setLabelsAttachedToBoxes({ value: value == "true", error: null })
        updateQuestion9({ LabelsAttachedToBoxesValue: value == "true" })
    }
    const onLabelsAttachedToBoxesCommentChanged = (e) => {
        setLabelsAttachedToBoxesComment({ value: e.target.value, error: null })
        updateQuestion9({ LabelsAttachedToBoxesCommentValue: e.target.value })
    }
    const onIsAllShippingBoxesInspectedChanged = (_, value) => {
        setIsAllShippingBoxesInspected({ value: value == "true", error: null })
        updateQuestion10({ IsAllShippingBoxesInspectedValue: value == "true" })
    }
    const onIsThereProblemsWithTemperatureChanged = (_, value) => {
        setIsThereProblemsWithTemperature({ value: value == "true", error: null })
        updateQuestion11({ IsThereProblemsWithTemperatureValue: value == "true" })
    }
    const onDeviceIdsChanged = (value) => {
        setDeviceIds({ value: value.join(","), error: null })
        updateQuestion11({ DeviceIdsValue: value.join(",") })
    }
    const onThereProblemsWithTemperatureCommentChanged = (e) => {
        setThereProblemsWithTemperatureComment({ value: e.target.value, error: null })
        updateQuestion11({ ThereProblemsWithTemperatureCommentValue: e.target.value })
    }
    const onIsThereAlarmsOrExcursionsTemperatureChanged = (_, value) => {
        setIsThereAlarmsOrExcursionsTemperature({ value: value == "true", error: null })
        updateQuestion12({ IsThereAlarmsOrExcursionsTemperatureValue: value == "true" })
    }
    const onThereAlarmsOrExcursionsTemperatureCommentChanged = (e) => {
        setThereAlarmsOrExcursionsTemperatureComment({ value: e.target.value, error: null })
        updateQuestion12({ ThereAlarmsOrExcursionsTemperatureCommentValue: e.target.value })
    }
    const onInsColdStoreArrivalDateChanged = (value) => {
        setInsColdStoreArrivalDate({ value: value, error: null })
        updateQuestion12({ InsColdStoreArrivalDateValue: value })
    }
    const onTemperatureAlarmShakeTestResultsChanged = (e) => {
        setTemperatureAlarmShakeTestResults({ value: e.target.value, error: null })
        updateQuestion12({ TemperatureAlarmShakeTestResultsValue: e.target.value })
    }
    const onDateOfInspectionChanged = (value) => {
        setDateOfInspection({ value: value, error: null })
        updateQuestion13({ DateOfInspectionValue: value })
    }
    const onIsThereAnyAdditionalCommentsChanged = (_, value) => {
        setIsThereAnyAdditionalComments({ value: value == "true", error: null })
        updateQuestion14({ IsThereAnyAdditionalCommentsValue: value == "true" })
    }
    const onOtherCommentsChanged = (e) => {
        setOtherComments({ value: e.target.value, error: null })
        updateQuestion14({ OtherCommentsValue: e.target.value })
    }

    const dispatch = useDispatch()

    const updateQuestion2 = ({ IsShipmentInfoGoodValue } = {}) => {
        dispatch(
            updateIsShipmentInfoGood({
                VarTransactionId: varId,
                IsShipmentInfoGood: IsShipmentInfoGoodValue ?? IsShipmentInfoGood.value
            })
        )
    }
    const updateQuestion3 = ({ IsPreAdviceReceivedInTimeValue, DaysPassedBetweenReceiptAndShipmentValue } = {}) => {
        dispatch(
            updateIsPreAdviceReceivedInTime({
                VarTransactionId: varId,
                IsPreAdviceReceivedInTime: IsPreAdviceReceivedInTimeValue ?? IsPreAdviceReceivedInTime.value,
                DaysPassedBetweenReceiptAndShipment: DaysPassedBetweenReceiptAndShipmentValue ?? DaysPassedBetweenReceiptAndShipment.value
            })
        )
    }
    const updateQuestion4 = ({ IsPreAdviceWithAllDocsValue, PreAdviceInvoiceValue, PreAdvicePackingListValue, PreAdviceBatchCertificateValue, PreAdviceCertificateOfOriginValue,
        PreAdviceCertificateOfConformityValue, PreAdviceCertificateOfAnalysisValue, PreAdviceOtherCertificateValue, PreAdviceAdditionalCommentsValue } = {}) => {
        dispatch(
            updateIsPreAdviceWithAllDocs({
                VarTransactionId: varId,
                IsPreAdviceWithAllDocs: IsPreAdviceWithAllDocsValue ?? IsPreAdviceWithAllDocs.value,
                PreAdviceInvoice: PreAdviceInvoiceValue ?? PreAdviceInvoice.value,
                PreAdvicePackingList: PreAdvicePackingListValue ?? PreAdvicePackingList.value,
                PreAdviceBatchCertificate: PreAdviceBatchCertificateValue ?? PreAdviceBatchCertificate.value,
                PreAdviceCertificateOfOrigin: PreAdviceCertificateOfOriginValue ?? PreAdviceCertificateOfOrigin.value,
                PreAdviceCertificateOfConformity: PreAdviceCertificateOfConformityValue ?? PreAdviceCertificateOfConformity.value,
                PreAdviceCertificateOfAnalysis: PreAdviceCertificateOfAnalysisValue ?? PreAdviceCertificateOfAnalysis.value,
                PreAdviceOtherCertificate: PreAdviceOtherCertificateValue ?? PreAdviceOtherCertificate.value,
                PreAdviceAdditionalComments: PreAdviceAdditionalCommentsValue ?? PreAdviceAdditionalComments.value,
            })
        )
    }
    const updateQuestion5 = ({ IsFlightArrivedOnTimeValue, ActualDateOfArrivalValue } = {}) => {
        dispatch(
            updateIsFlightArrivedOnTime({
                VarTransactionId: varId,
                IsFlightArrivedOnTime: IsFlightArrivedOnTimeValue ?? IsFlightArrivedOnTime.value,
                ActualDateOfArrival: ActualDateOfArrivalValue ?? ActualDateOfArrival.value
            })
        )
    }
    const updateQuestion6 = ({ IsAtDeliveryReceivedAllRequiredDocumentsValue, InvoiceValue, PackingListValue, ReleaseCertificateValue,
        CertificateOfOriginValue, CertificateOfConformityValue, CertificateOfAnalysisValue, OtherCertificateValue, ShipmentDocumentCommentsValue } = {}) => {
        dispatch(
            updateIsAtDeliveryReceivedAllRequiredDocuments({
                VarTransactionId: varId,
                IsAtDeliveryReceivedAllRequiredDocuments: IsAtDeliveryReceivedAllRequiredDocumentsValue ?? IsAtDeliveryReceivedAllRequiredDocuments.value,
                Invoice: InvoiceValue ?? Invoice.value,
                PackingList: PackingListValue ?? PackingList.value,
                ReleaseCertificate: ReleaseCertificateValue ?? ReleaseCertificate.value,
                CertificateOfOrigin: CertificateOfOriginValue ?? CertificateOfOrigin.value,
                CertificateOfConformity: CertificateOfConformityValue ?? CertificateOfConformity.value,
                CertificateOfAnalysis: CertificateOfAnalysisValue ?? CertificateOfAnalysis.value,
                OtherCertificate: OtherCertificateValue ?? OtherCertificate.value,
                ShipmentDocumentComments: ShipmentDocumentCommentsValue ?? ShipmentDocumentComments.value
            })
        )
    }
    const updateQuestion7 = ({ IsBatchesMatchedWithPackingListValue, BatchesMatchedWithPackingListCommentValue } = {}) => {
        dispatch(
            updateIsBatchesMatchedWithPackingList({
                VarTransactionId: varId,
                IsBatchesMatchedWithPackingList: IsBatchesMatchedWithPackingListValue ?? IsBatchesMatchedWithPackingList.value,
                BatchesMatchedWithPackingListComment: BatchesMatchedWithPackingListCommentValue ?? BatchesMatchedWithPackingListComment.value
            })
        )
    }
    const updateQuestion8 = ({ GoodConditionOfBoxesOnArrivalValue, GoodConditionOfBoxesOnArrivalCommentValue } = {}) => {
        dispatch(
            updateGoodConditionOfBoxesOnArrival({
                VarTransactionId: varId,
                GoodConditionOfBoxesOnArrival: GoodConditionOfBoxesOnArrivalValue ?? GoodConditionOfBoxesOnArrival.value,
                GoodConditionOfBoxesOnArrivalComment: GoodConditionOfBoxesOnArrivalCommentValue ?? GoodConditionOfBoxesOnArrivalComment.value
            })
        )
    }
    const updateQuestion9 = ({ LabelsAttachedToBoxesValue, LabelsAttachedToBoxesCommentValue } = {}) => {
        dispatch(
            updateLabelsAttachedToBoxes({
                VarTransactionId: varId,
                LabelsAttachedToBoxes: LabelsAttachedToBoxesValue ?? LabelsAttachedToBoxes.value,
                LabelsAttachedToBoxesComment: LabelsAttachedToBoxesCommentValue ?? LabelsAttachedToBoxesComment.value
            })
        )
    }
    const updateQuestion10 = ({ IsAllShippingBoxesInspectedValue } = {}) => {
        dispatch(
            updateIsAllShippingBoxesInspected({
                VarTransactionId: varId,
                IsAllShippingBoxesInspected: IsAllShippingBoxesInspectedValue ?? IsAllShippingBoxesInspected.value
            })
        )
    }
    const updateQuestion11 = ({ IsThereProblemsWithTemperatureValue, DeviceIdsValue, ThereProblemsWithTemperatureCommentValue } = {}) => {
        dispatch(
            updateIsThereProblemsWithTemperature({
                VarTransactionId: varId,
                IsThereProblemsWithTemperature: IsThereProblemsWithTemperatureValue ?? IsThereProblemsWithTemperature.value,
                DeviceIds: DeviceIdsValue ?? DeviceIds.value,
                ThereProblemsWithTemperatureComment: ThereProblemsWithTemperatureCommentValue ?? ThereProblemsWithTemperatureComment.value
            })
        )
    }
    const updateQuestion12 = ({ IsThereAlarmsOrExcursionsTemperatureValue, ThereAlarmsOrExcursionsTemperatureCommentValue, InsColdStoreArrivalDateValue, TemperatureAlarmShakeTestResultsValue } = {}) => {
        dispatch(
            updateIsThereAlarmsOrExcursionsTemperature({
                VarTransactionId: varId,
                IsThereAlarmsOrExcursionsTemperature: IsThereAlarmsOrExcursionsTemperatureValue ?? IsThereAlarmsOrExcursionsTemperature.value,
                ThereAlarmsOrExcursionsTemperatureComment: ThereAlarmsOrExcursionsTemperatureCommentValue ?? ThereAlarmsOrExcursionsTemperatureComment.value,
                InsColdStoreArrivalDate: InsColdStoreArrivalDateValue ?? InsColdStoreArrivalDate.value,
                TemperatureAlarmShakeTestResults: TemperatureAlarmShakeTestResultsValue ?? TemperatureAlarmShakeTestResults.value
            })
        )
    }
    const updateQuestion13 = ({ DateOfInspectionValue } = {}) => {
        dispatch(
            updateDateOfInspection({
                VarTransactionId: varId,
                DateOfInspection: DateOfInspectionValue ?? DateOfInspection.value
            })
        )
    }
    const updateQuestion14 = ({ IsThereAnyAdditionalCommentsValue, OtherCommentsValue } = {}) => {
        dispatch(
            updateIsThereAnyAdditionalComments({
                VarTransactionId: varId,
                IsThereAnyAdditionalComments: IsThereAnyAdditionalCommentsValue ?? IsThereAnyAdditionalComments.value,
                OtherComments: OtherCommentsValue ?? OtherComments.value
            })
        )
    }
    const updateObj = () => {
        var validation = true
        //1
        validation = updateQuestionnaireInfoCorrectForm()
        //2
        if (IsShipmentInfoGood.value == null) {
            setIsShipmentInfoGood({ error: "REQUIRED" })
            validation = false
        } else
            updateQuestion2()
        //3
        if (IsPreAdviceReceivedInTime.value == null) {
            setIsPreAdviceReceivedInTime({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsPreAdviceReceivedInTime.value == false && (DaysPassedBetweenReceiptAndShipment.value == null || isNaN(DaysPassedBetweenReceiptAndShipment.value) || DaysPassedBetweenReceiptAndShipment.value == '')) {
                setDaysPassedBetweenReceiptAndShipment({ error: "REQUIRED" })
                validation = false
            } else 
                updateQuestion3()
        }
        //4
        if (IsPreAdviceWithAllDocs.value == null) {
            setIsPreAdviceWithAllDocs({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsPreAdviceWithAllDocs.value == false) {
                if ((PreAdviceInvoice.value == null || PreAdviceInvoice.value == false) &&
                    (PreAdvicePackingList.value == null || PreAdvicePackingList.value == false) &&
                    (PreAdviceBatchCertificate.value == null || PreAdviceBatchCertificate.value == false) &&
                    (PreAdviceCertificateOfOrigin.value == null || PreAdviceCertificateOfOrigin.value == false) &&
                    (PreAdviceCertificateOfConformity.value == null || PreAdviceCertificateOfConformity.value == false) &&
                    (PreAdviceCertificateOfAnalysis.value == null || PreAdviceCertificateOfAnalysis.value == false) &&
                    (PreAdviceOtherCertificate.value == null || PreAdviceOtherCertificate.value == false)) {
                    setIsPreAdviceWithAllDocs({ value: false, error: "AT_LEAST_ONE_SELECTED_OPTION_IS_REQUIRED" })
                    validation = false
                }
                if (validation) updateQuestion4()
            } else
                updateQuestion4()
        }
        //5
        if (IsFlightArrivedOnTime.value == null) {
            setIsFlightArrivedOnTime({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsFlightArrivedOnTime.value == false && ActualDateOfArrival.value == null) {
                setActualDateOfArrival({ error: "REQUIRED" })
                validation = false
            } else
                updateQuestion5()
        }
        //6
        if (IsAtDeliveryReceivedAllRequiredDocuments.value == null) {
            setIsAtDeliveryReceivedAllRequiredDocuments({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsAtDeliveryReceivedAllRequiredDocuments.value == false) {
                if ((Invoice.value == null || Invoice.value == false) &&
                    (PackingList.value == null || PackingList.value == false) &&
                    (ReleaseCertificate.value == null || ReleaseCertificate.value == false) &&
                    (CertificateOfOrigin.value == null || CertificateOfOrigin.value == false) &&
                    (CertificateOfConformity.value == null || CertificateOfConformity.value == false) &&
                    (CertificateOfAnalysis.value == null || CertificateOfAnalysis.value == false) &&
                    (OtherCertificate.value == null || OtherCertificate.value == false)) {
                    setIsAtDeliveryReceivedAllRequiredDocuments({ value: false, error: "AT_LEAST_ONE_SELECTED_OPTION_IS_REQUIRED" })
                    validation = false
                }
                if (validation) updateQuestion6()
            } else
                updateQuestion6()
        }
        //7
        if (IsBatchesMatchedWithPackingList.value == null) {
            setIsBatchesMatchedWithPackingList({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsBatchesMatchedWithPackingList.value == false && (BatchesMatchedWithPackingListComment.value == null || BatchesMatchedWithPackingListComment.value == '')) {
                setBatchesMatchedWithPackingListComment({ error: "REQUIRED" })
                validation = false
            } else
                updateQuestion7()
        }
        //8
        if (GoodConditionOfBoxesOnArrival.value == null) {
            setGoodConditionOfBoxesOnArrival({ error: "REQUIRED" })
            validation = false
        } else {
            if (GoodConditionOfBoxesOnArrival.value == false && (GoodConditionOfBoxesOnArrivalComment.value == null || GoodConditionOfBoxesOnArrivalComment.value == '')) {
                setGoodConditionOfBoxesOnArrivalComment({ error: "REQUIRED" })
                validation = false
            } else
                updateQuestion8()
        }
        //9
        if (LabelsAttachedToBoxes.value == null) {
            setLabelsAttachedToBoxes({ error: "REQUIRED" })
            validation = false
        } else {
            if (LabelsAttachedToBoxes.value == false && (LabelsAttachedToBoxesComment.value == null || LabelsAttachedToBoxesComment.value == '')) {
                setLabelsAttachedToBoxesComment({ error: "REQUIRED" })
                validation = false
            } else
                updateQuestion9()
        }
        //10
        if (IsAllShippingBoxesInspected.value == null) {
            setLabelsAttachedToBoxes({ error: "REQUIRED" })
            validation = false
        } else updateQuestion10()
        //11
        if (IsThereProblemsWithTemperature.value == null) {
            setIsThereProblemsWithTemperature({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsThereProblemsWithTemperature.value == true && (DeviceIds.value == null || DeviceIds.value == '')) {
                setDeviceIds({ error: "REQUIRED" })
                validation = false
            } else
                updateQuestion11()
        }
        //12
        if (IsThereAlarmsOrExcursionsTemperature.value == null) {
            setIsThereAlarmsOrExcursionsTemperature({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsThereAlarmsOrExcursionsTemperature.value == true) {
                if (ThereAlarmsOrExcursionsTemperatureComment.value == null || ThereAlarmsOrExcursionsTemperatureComment.value == '') {
                    setThereAlarmsOrExcursionsTemperatureComment({ error: "REQUIRED" })
                    validation = false
                }
                if (InsColdStoreArrivalDate.value == null) {
                    setInsColdStoreArrivalDate({ error: "REQUIRED" })
                    validation = false
                }
                if (validation) updateQuestion12()
            } else
                    updateQuestion12()
        }
        //13
        if (DateOfInspection.value == null) {
            setDateOfInspection({ error: "REQUIRED" })
            validation = false
        } else updateQuestion13()
        //14
        if (IsThereAnyAdditionalComments.value == null) {
            setIsThereAnyAdditionalComments({ error: "REQUIRED" })
            validation = false
        } else {
            if (IsThereAnyAdditionalComments.value == true && (OtherComments.value == null || OtherComments.value == '')) {
                setOtherComments({ error: "REQUIRED" })
                validation = false
            } else
                updateQuestion14()
        }
        return validation
    }

    const [questionnaireInfoCorrectForm, updateQuestionnaireInfoCorrectForm] = QuestionnaireInfoCorrectForm({ varId });
    const [batchPackingsQuestion7, /*updateGoodConditionAttachmentQuestion8*/] = VarBatchPackingsForm({ label: "BATCH_PACKINGS", varId });
    const [goodConditionAttachmentQuestion8, /*updateGoodConditionAttachmentQuestion8*/] = VarAttachmentsForm({ label: varFieldAttachments.find(x => x.Id == "GoodConditionOfBoxesOnArrivalUrlAttachment").FieldName ?? "Attach pictures", varId, varFieldAttachmentId: "GoodConditionOfBoxesOnArrivalUrlAttachment", fileTypes: "image/png,image/jpg,image/jpeg" });
    const [labelsAttachedToBoxesAttachmentQuestion9, /*updateLabelsAttachedToBoxesAttachmentQuestion9*/] = VarAttachmentsForm({ label: varFieldAttachments.find(x => x.Id == "LabelsAttachedToBoxesUrlAttachment").FieldName ?? "Attach pictures", varId, varFieldAttachmentId: "LabelsAttachedToBoxesUrlAttachment", fileTypes: "image/png,image/jpg,image/jpeg" });
    const [thereAlarmsOrExcursionsTempAttachmentPdfQuestion12, /*updateThereAlarmsOrExcursionsTempAttachmentPdfQuestion12*/] = VarAttachmentsForm({ label: varFieldAttachments.find(x => x.Id == "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPdf").FieldName ?? "Please upload the PDF files from the device", varId, varFieldAttachmentId: "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPdf", fileTypes: "application/pdf" });
    const [thereAlarmsOrExcursionsTempAttachmentAlarmQuestion12, /*updateThereAlarmsOrExcursionsTempAttachmentAlarmQuestion12*/] = VarAttachmentsForm({ label: varFieldAttachments.find(x => x.Id == "ThereAlarmsOrExcursionsTemperatureUrlAttachmentAlarm").FieldName ?? "Fill in electronic Device Alarm Report Form", varId, varFieldAttachmentId: "ThereAlarmsOrExcursionsTemperatureUrlAttachmentAlarm", fileTypes: "application/pdf" });
    const [thereAlarmsOrExcursionsTempAttachmentPicturesQuestion12, /*updateThereAlarmsOrExcursionsTempAttachmentPicturesQuestion12*/] = VarAttachmentsForm({ label: varFieldAttachments.find(x => x.Id == "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPictures").FieldName ?? "Attach pictures", varId, varFieldAttachmentId: "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPictures", fileTypes: "image/png,image/jpg,image/jpeg" });

    const questionnaireForm = (
        <React.Fragment>
            {questionnaireInfoCorrectForm}
            <SectionWithQuestionLabel text="QUESTION_2" questionText="TOOLTIP_2" />
            <RadioYesNoNull text="LABEL_2" value={IsShipmentInfoGood.value} error={IsShipmentInfoGood.error} ariaLabel="IsShipmentInfoGood" onChange={onIsShipmentInfoGoodChanged} readonly={varx.ImSupervisor} />
            {IsShipmentInfoGood.value == false ?
                (<React.Fragment>
                    <br /><Label style={{ fontWeight: "bold" }} text="COMPLAINT_1" /> <a style={{ fontWeight: "bold", color: "blue" }} target="_blank" href="https://cica.unicef.org">{Translation.t("COMPLAINT_2")}</a> <Label style={{ fontWeight: "bold" }} text="COMPLAINT_3" /><br />
                </React.Fragment>) : null}
            <SectionWithQuestionLabel text="QUESTION_3" questionText="TOOLTIP_3" />
            <RadioYesNoNull text="LABEL_3" value={IsPreAdviceReceivedInTime.value} error={IsPreAdviceReceivedInTime.error} ariaLabel="IsPreAdviceReceivedInTime" onChange={onIsPreAdviceReceivedInTimeChanged} readonly={varx.ImSupervisor} /><br />
            {IsPreAdviceReceivedInTime.value == false ?
                (<React.Fragment>
                    <Label text="LABEL_3_2" />
                    <Input type="number" value={DaysPassedBetweenReceiptAndShipment.value} error={DaysPassedBetweenReceiptAndShipment.error} ariaLabel="DaysPassedBetweenReceiptAndShipment" onChange={onDaysPassedBetweenReceiptAndShipmentChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>) : null}
            <SectionLabel text="QUESTION_4" />
            <RadioYesNoNull text="LABEL_4" value={IsPreAdviceWithAllDocs.value} error={IsPreAdviceWithAllDocs.error} ariaLabel="IsPreAdviceWithAllDocs" onChange={onIsPreAdviceWithAllDocsChanged} readonly={varx.ImSupervisor} />
            {IsPreAdviceWithAllDocs.value == false ?
                (<React.Fragment>
                    <Label text="LABEL_4_6_2" style={{ fontWeight: "bold" }} /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdviceInvoice.value} error={PreAdviceInvoice.error} aria-label="PreAdviceInvoice" onChange={onPreAdviceInvoiceChanged} disabled={varx.ImSupervisor} /><Label text="INVOICE" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdvicePackingList.value} error={PreAdvicePackingList.error} aria-label="PreAdvicePackingList" onChange={onPreAdvicePackingListChanged} disabled={varx.ImSupervisor} /><Label text="PACKING_LIST" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdviceBatchCertificate.value} error={PreAdviceBatchCertificate.error} aria-label="PreAdviceBatchCertificate" onChange={onPreAdviceBatchCertificateChanged} disabled={varx.ImSupervisor} /><Label text="RELEASE_CERTIFICATE" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdviceCertificateOfOrigin.value} error={PreAdviceCertificateOfOrigin.error} aria-label="PreAdviceCertificateOfOrigin" onChange={onPreAdviceCertificateOfOriginChanged} disabled={varx.ImSupervisor} /><Label text="CERTIFICATE_OF_ORIGIN" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdviceCertificateOfConformity.value} error={PreAdviceCertificateOfConformity.error} aria-label="PreAdviceCertificateOfConformity" onChange={onPreAdviceCertificateOfConformityChanged} disabled={varx.ImSupervisor} /><Label text="CERTIFICATE_OF_CONFORMITY" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdviceCertificateOfAnalysis.value} error={PreAdviceCertificateOfAnalysis.error} aria-label="PreAdviceCertificateOfAnalysis" onChange={onPreAdviceCertificateOfAnalysisChanged} disabled={varx.ImSupervisor} /><Label text="CERTIFICATE_OF_ANALYSIS" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PreAdviceOtherCertificate.value} error={PreAdviceOtherCertificate.error} aria-label="PreAdviceOtherCertificate" onChange={onPreAdviceOtherCertificateChanged} disabled={varx.ImSupervisor} /><Label text="OTHER_SPECIFY" /><br /><br />
                    <Label text="COMMENT_LABEL_4_6" />
                    <Input value={PreAdviceAdditionalComments.value} multiline error={PreAdviceAdditionalComments.error} ariaLabel="PreAdviceAdditionalComments" onChange={onPreAdviceAdditionalCommentsChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>) : null}
            <SectionLabel text="QUESTION_5" />
            <RadioYesNoNull text="LABEL_5" value={IsFlightArrivedOnTime.value} error={IsFlightArrivedOnTime.error} ariaLabel="IsFlightArrivedOnTime" onChange={onIsFlightArrivedOnTimeChanged} readonly={varx.ImSupervisor} />
            {IsFlightArrivedOnTime.value == false ? 
                (<React.Fragment>
                    <Label text="LABEL_5_2" />
                    <Date value={ActualDateOfArrival.value} error={ActualDateOfArrival.error} onChange={onActualDateOfArrivalChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>) : null}
            <SectionLabel text="QUESTION_6" />
            <RadioYesNoNull text="LABEL_6" value={IsAtDeliveryReceivedAllRequiredDocuments.value} ariaLabel="IsAtDeliveryReceivedAllRequiredDocuments" onChange={onIsAtDeliveryReceivedAllRequiredDocumentsChanged} readonly={varx.ImSupervisor} />
            {IsAtDeliveryReceivedAllRequiredDocuments.value == false ? (
                <React.Fragment>
                    <Label text="LABEL_4_6_2" style={{ fontWeight: "bold" }} /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={Invoice.value} error={Invoice.error} onChange={onInvoiceChanged} aria-label="Invoice" disabled={varx.ImSupervisor} /><Label text="INVOICE" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PackingList.value} error={PackingList.error} onChange={onPackingListChanged} aria-label="PackingList" disabled={varx.ImSupervisor} /><Label text="PACKING_LIST" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={ReleaseCertificate.value} error={ReleaseCertificate.error} onChange={onReleaseCertificateChanged} aria-label="ReleaseCertificate" disabled={varx.ImSupervisor} /><Label text="RELEASE_CERTIFICATE" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={CertificateOfOrigin.value} error={CertificateOfOrigin.error} onChange={onCertificateOfOriginChanged} aria-label="CertificateOfOrigin" disabled={varx.ImSupervisor} /><Label text="CERTIFICATE_OF_ORIGIN" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={CertificateOfConformity.value} error={CertificateOfConformity.error} onChange={onCertificateOfConformityChanged} aria-label="CertificateOfConformity" disabled={varx.ImSupervisor} /><Label text="CERTIFICATE_OF_CONFORMITY" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={CertificateOfAnalysis.value} error={CertificateOfAnalysis.error} onChange={onCertificateOfAnalysisChanged} aria-label="CertificateOfAnalysis" disabled={varx.ImSupervisor} /><Label text="CERTIFICATE_OF_ANALYSIS" /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={OtherCertificate.value} error={OtherCertificate.error} onChange={onOtherCertificateChanged} aria-label="OtherCertificate" disabled={varx.ImSupervisor} /><Label text="OTHER_SPECIFY" /><br /><br />
                    <Label text="COMMENT_LABEL_4_6" /><br /><br />
                    <Input multiline value={ShipmentDocumentComments.value} error={ShipmentDocumentComments.error} onChange={onShipmentDocumentCommentsChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>
            ) : null}
            <SectionLabel text="QUESTION_7" />
            <RadioYesNoNull text="LABEL_7" value={IsBatchesMatchedWithPackingList.value} error={IsBatchesMatchedWithPackingList.error} onChange={onIsBatchesMatchedWithPackingListChanged} ariaLabel="IsBatchesMatchedWithPackingList" readonly={varx.ImSupervisor} />
            {IsBatchesMatchedWithPackingList.value == false ? (
                <React.Fragment>
                    <Label text="COMMENT_LABEL_7" />
                    <Input multiline value={BatchesMatchedWithPackingListComment.value} error={BatchesMatchedWithPackingListComment.error} onChange={onBatchesMatchedWithPackingListCommentChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>
            ) : null}
            {batchPackingsQuestion7}
            <SectionLabel text="QUESTION_8" />
            <RadioYesNoNull text="LABEL_8" value={GoodConditionOfBoxesOnArrival.value} error={GoodConditionOfBoxesOnArrival.error} onChange={onGoodConditionOfBoxesOnArrivalChanged} ariaLabel="GoodConditionOfBoxesOnArrival" readonly={varx.ImSupervisor} />
            {GoodConditionOfBoxesOnArrival.value == false ? (
                <React.Fragment>
                    <Label text="COMMENT_LABEL" />
                    <Input multiline value={GoodConditionOfBoxesOnArrivalComment.value} error={GoodConditionOfBoxesOnArrivalComment.error} onChange={onGoodConditionOfBoxesOnArrivalCommentChanged} readonly={varx.ImSupervisor} />
                    {/*<Label text="(pictures GoodConditionOfBoxesOnArrival UrlAttachment)" />*/}
                    {goodConditionAttachmentQuestion8}
                </React.Fragment>
            ) : null}
            <SectionLabel text="QUESTION_9" />
            <RadioYesNoNull text="LABEL_9" value={LabelsAttachedToBoxes.value} error={LabelsAttachedToBoxes.error} onChange={onLabelsAttachedToBoxesChanged} ariaLabel="LabelsAttachedToBoxes" readonly={varx.ImSupervisor} />
            {LabelsAttachedToBoxes.value == false ? (
                <React.Fragment>
                    <Label text="COMMENT_LABEL" />
                    <Input multiline value={LabelsAttachedToBoxesComment.value} error={LabelsAttachedToBoxesComment.error} onChange={onLabelsAttachedToBoxesCommentChanged} readonly={varx.ImSupervisor} />
                    {/*<Label text="(pictures LabelsAttachedToBoxes UrlAttachment)" />*/}
                    {labelsAttachedToBoxesAttachmentQuestion9}
                </React.Fragment>
            ) : null}
            <SectionWithQuestionLabel text="QUESTION_10" questionText="TOOLTIP_10" /><br />
            <RadioYesNoNull text="LABEL_10" value={IsAllShippingBoxesInspected.value} error={IsAllShippingBoxesInspected.error} onChange={onIsAllShippingBoxesInspectedChanged} ariaLabel="IsAllShippingBoxesInspected" readonly={varx.ImSupervisor} />
            {IsAllShippingBoxesInspected.value == false ? <Label style={{ color: "red" }} text="PLEASE_INSPECT_BOXES" /> : null}
            <SectionLabel text="QUESTION_11" />
            <RadioYesNoNull text="LABEL_11" value={IsThereProblemsWithTemperature.value} error={IsThereProblemsWithTemperature.error} onChange={onIsThereProblemsWithTemperatureChanged} ariaLabel="IsThereProblemsWithTemperature" readonly={varx.ImSupervisor} />
            {IsThereProblemsWithTemperature.value == true ? (
                <React.Fragment>
                    <Label text="LABEL_11_2" />
                    <MultipleSelect items={devices} value={DeviceIds.value} error={DeviceIds.error} onChange={onDeviceIdsChanged} readonly={varx.ImSupervisor} />
                    <Label text="COMMENT_BOXES" />
                    <Input multiline value={ThereProblemsWithTemperatureComment.value} error={ThereProblemsWithTemperatureComment.error} onChange={onThereProblemsWithTemperatureCommentChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>
            ) : null}
            <SectionWithQuestionLabel text="QUESTION_12" questionText="TOOLTIP_12" /><br />
            <RadioYesNoNull text="LABEL_12" value={IsThereAlarmsOrExcursionsTemperature.value} error={IsThereAlarmsOrExcursionsTemperature.error} onChange={onIsThereAlarmsOrExcursionsTemperatureChanged} ariaLabel="IsThereAlarmsOrExcursionsTemperature" readonly={varx.ImSupervisor} />
            {IsThereAlarmsOrExcursionsTemperature.value == true ? (
                <React.Fragment>
                    <hr />
                    {thereAlarmsOrExcursionsTempAttachmentPdfQuestion12}<hr />
                    <a href="/VarTransactions/DownloadVARAlarmReportForm" target="_blank"><BasicLabel text="DOWNLOAD_VAR_ALARM_REPORT_FORM_PDF" /></a><br />
                    {thereAlarmsOrExcursionsTempAttachmentAlarmQuestion12}<hr />
                    {thereAlarmsOrExcursionsTempAttachmentPicturesQuestion12}<hr />
                    <Label text="COMMENT_LABEL" />
                    <Input multiline value={ThereAlarmsOrExcursionsTemperatureComment.value} error={ThereAlarmsOrExcursionsTemperatureComment.error} onChange={onThereAlarmsOrExcursionsTemperatureCommentChanged} readonly={varx.ImSupervisor} />
                    <Label text="LABEL_12_2" />
                    <DateTime value={varx.InsColdStoreArrivalDate} error={InsColdStoreArrivalDate.error} onChange={onInsColdStoreArrivalDateChanged} readonly={varx.ImSupervisor} />
                    <Label text="LABEL_12_3" />
                    <Input value={TemperatureAlarmShakeTestResults.value} error={TemperatureAlarmShakeTestResults.error} onChange={onTemperatureAlarmShakeTestResultsChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>
                ) : null}
            <SectionLabel text="QUESTION_13" />
            <Label text="LABEL_13" />
            <Date value={DateOfInspection.value} error={DateOfInspection.error} onChange={onDateOfInspectionChanged} readonly={varx.ImSupervisor} />
            <SectionLabel text="QUESTION_14" />
            <RadioYesNoNull text="LABEL_14" value={IsThereAnyAdditionalComments.value} error={IsThereAnyAdditionalComments.error} onChange={onIsThereAnyAdditionalCommentsChanged} ariaLabel="IsThereAnyAdditionalComments" readonly={varx.ImSupervisor} />
            {IsThereAnyAdditionalComments.value == true ? (
                <React.Fragment>
                    <Label text="COMMENT_LABEL" /><Input multiline value={OtherComments.value} error={OtherComments.error} onChange={onOtherCommentsChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>
            ) : null}
        </React.Fragment>
    )
    return [questionnaireForm, updateObj];
}

export default QuestionnaireForm;